import {Box, Col, Row} from 'components/Grid';
import React, {FC} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {plural} from 'core/helpers';

interface IProps {
    text: string;
    categoryName?: string;
    minPrice?: number;
    maxPrice?: number;
    className?: string;
}

export const CatalogSeoTextBottom: FC<IProps> = ({text, categoryName, minPrice = 0, maxPrice = 0, className}) => {
    const pluralArray = ['рубля', 'pублей', 'рублей'];

    if (!(Boolean(minPrice) && Boolean(maxPrice) && text)) {
        return null;
    }

    return (
        <Box className={className}>
            {text && (
                <div className={style.grid}>
                    {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                    <div className={style.main} dangerouslySetInnerHTML={{__html: text}} />
                </div>
            )}
            {Boolean(minPrice) && Boolean(maxPrice) && categoryName && (
                <Row className={style.seoCaption}>
                    <Col sm={12}>
                        <Typography variant={'label-14-m'}>
                            В винотеках SimpleWine вы можете купить товары категории {categoryName} по цене от{' '}
                            {minPrice} {plural(minPrice, pluralArray)} до {maxPrice} {plural(maxPrice, pluralArray)}.
                        </Typography>
                    </Col>
                </Row>
            )}
        </Box>
    );
};
